/**
 * Algolia Tracking
 * Algolia Analytics tracking
 */

/**
 * Track view of search results
 * @param {string[]} objectIDs
 * @param {string} queryID
 */
export function trackView(objectIDs, queryID) {
  if (!window.AlgoliaAnalyticsHandlers?.trackView) {
    console.warn('AlgoliaAnalyticsHandlers.trackView not available');
    return;
  }

  window.AlgoliaAnalyticsHandlers.trackView(objectIDs, queryID);
  console.log('📊 Algolia view tracked:', objectIDs.length, 'results');
}

/**
 * Track empty results
 * @param {string} queryID
 */
export function trackEmptyResults(queryID) {
  if (!window.AlgoliaAnalyticsHandlers?.trackEmptyResults) {
    console.warn('AlgoliaAnalyticsHandlers.trackEmptyResults not available');
    return;
  }

  window.AlgoliaAnalyticsHandlers.trackEmptyResults(queryID);
  console.log('📊 Algolia empty results tracked');
}

/**
 * Track sort change
 * @param {string} sortValue
 * @param {string} queryID
 */
export function trackSort(sortValue, queryID) {
  if (!window.AlgoliaAnalyticsHandlers?.trackSort) {
    console.warn('AlgoliaAnalyticsHandlers.trackSort not available');
    return;
  }

  window.AlgoliaAnalyticsHandlers.trackSort(sortValue, queryID);
  console.log('📊 Algolia sort tracked:', sortValue);
}

/**
 * Track filter change
 * @param {string} filterName
 * @param {string} filterValue
 * @param {string} queryID
 */
export function trackFilter(filterName, filterValue, queryID) {
  if (!window.AlgoliaAnalyticsHandlers?.trackFilter) {
    console.warn('AlgoliaAnalyticsHandlers.trackFilter not available');
    return;
  }

  window.AlgoliaAnalyticsHandlers.trackFilter(filterName, filterValue, queryID);
  console.log('📊 Algolia filter tracked:', filterName, '=', filterValue);
}

/**
 * Track camp click
 * @param {string} objectID
 * @param {number} position
 * @param {string} queryID
 */
export function trackClick(objectID, position, queryID) {
  if (!window.AlgoliaAnalyticsHandlers?.trackClick) {
    console.warn('AlgoliaAnalyticsHandlers.trackClick not available');
    return;
  }

  window.AlgoliaAnalyticsHandlers.trackClick(objectID, position, queryID);
  console.log('📊 Algolia click tracked:', objectID, 'at position', position);
}

console.log('📦 Algolia tracking module loaded');
